module.exports = __webpack_public_path__ + "static/iris-kotsinas-cv-2022-mars-cc54959b562d101adb0f3696e4bf2722.pdf";